// TABBED CONTENT JS

try {
	const aL = document.querySelectorAll(".component__tabbedContent");
	if (aL.length) {
		for (let i = aL.length - 1; i >= 0; i--) {
			const rows = aL[i].querySelectorAll(".tabbedContent__container");
			for (let i = rows.length - 1; i >= 0; i--) {
				rows[i]
					.querySelector(".tabbedContent__accordionHeader")
					.addEventListener("click", function(e) {
						e.preventDefault();
						this.parentNode.classList.toggle("active-tab");
					});
			}

			const tabs = aL[i].querySelectorAll(".tabbedContent__tabs li");
			for (let i = tabs.length - 1; i >= 0; i--) {
				tabs[i].addEventListener("click", function(e) {
					e.preventDefault();
					let targetID = this.getAttribute("data-target");

					for (let i = tabs.length - 1; i >= 0; i--) {
						tabs[i].classList.remove("active-tab");
					}
					this.classList.add("active-tab");

					for (let i = rows.length - 1; i >= 0; i--) {
						rows[i]
							.querySelector(".tabbedContent__content")
							.classList.remove("active-tab");
					}
					document.querySelector("#" + targetID).classList.add("active-tab");
				});
			}
		}
	}
} catch (e) {
	console.error(e);
}
